import React, { useMemo } from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { getStoredUser } from '../../utils/userStorage';

const StatCard = ({ value, label, color = '#1f1f1f', bgColor = '#fff' }) => (
  <Box
    sx={{
      bgcolor: bgColor,
      borderRadius: 2,
      p: 4,
      textAlign: 'left',
      border: '1px solid #E2E8F0',
      transition: 'all 0.2s ease-in-out',
      '&:hover': {
        boxShadow: '0 2px 8px 0 rgba(0, 0, 0, 0.1)',
      },
    }}
  >
    <Typography
      variant="h4"
      sx={{
        fontWeight: 700,
        color: color,
        fontSize: '1.5rem',
        lineHeight: '2rem',
        mb: 1,
      }}
    >
      {value}
    </Typography>
    <Typography
      variant="body2"
      sx={{
        color: '#737373',
        fontSize: '0.875rem',
        lineHeight: '1.25rem',
      }}
    >
      {label}
    </Typography>
  </Box>
);

const ProjectStats = ({ projects = [] }) => {
  // Calculate statistics
  const totalProjects = projects.length;

  const activeProjects = useMemo(() => projects.filter(projectData => {
    const project = projectData.project || projectData;
    const subscription = projectData.subscription;

    if (!subscription) return false;

    const now = new Date();
    const endDate = new Date(subscription.end_date);
    const isExpired = endDate < now;
    const isActive = subscription.status === 'active' || subscription.status === 'trial';

    return isActive && !isExpired;
  }).length, [projects]);

  const readOnlyProjects = useMemo(() => projects.filter(projectData => {
    const project = projectData.project || projectData;
    const userInfo = getStoredUser() || {};
    const currentUserEmail = userInfo.email || '';
    return project.created_by_info?.email !== currentUserEmail;
  }).length, [projects]);

  const inactiveProjects = useMemo(() => projects.filter(projectData => {
    const project = projectData.project || projectData;
    const subscription = projectData.subscription;

    if (!subscription) return true;

    const now = new Date();
    const endDate = new Date(subscription.end_date);
    const isExpired = endDate < now;
    const isActive = subscription.status === 'active' || subscription.status === 'trial';

    return !isActive || isExpired;
  }).length, [projects]);

  return (
    <Box sx={{ mb: 6 }}>
      <Grid container spacing={3}>
        <Grid item xs={6} sm={3}>
          <StatCard
            value={totalProjects}
            label="Total Projects"
            color="#1f1f1f"
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <StatCard
            value={activeProjects}
            label="Active"
            color="#00bfff"
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <StatCard
            value={readOnlyProjects}
            label="Read Only"
            color="#828282"
          />
        </Grid>
        <Grid item xs={6} sm={3}>
          <StatCard
            value={inactiveProjects}
            label="Inactive"
            color="#ef4343"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProjectStats;